export default "__VITE_ASSET__DL8tn0VD__"